
import * as awsAmplifyRuntime$_2G4792L1saC8v_7Obw0Z9iqGQVQqYC9I_a6phS_Ut80 from '/codebuild/output/src3966139036/src/portals-fe/node_modules/@nuxt/image/dist/runtime/providers/awsAmplify'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "awsAmplify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['awsAmplify']: { provider: awsAmplifyRuntime$_2G4792L1saC8v_7Obw0Z9iqGQVQqYC9I_a6phS_Ut80, defaults: {} }
}
        